/**
 * @generated SignedSource<<901bc6db8b5ceb06f89158b531c8c430>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselThumb_videoVimeo$data = {
  readonly thumbnail: string | null;
  readonly " $fragmentType": "HeroCarouselThumb_videoVimeo";
};
export type HeroCarouselThumb_videoVimeo$key = {
  readonly " $data"?: HeroCarouselThumb_videoVimeo$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_videoVimeo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselThumb_videoVimeo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includePlayButton",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "pad",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "size",
          "value": "w100h75"
        }
      ],
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
    }
  ],
  "type": "VideoVimeo",
  "abstractKey": null
};

(node as any).hash = "1d36942890a6f6b17e3d7b39ac5c63b6";

export default node;
